import { Check } from 'lucide-react'
import { Row } from '@/components/core'

interface StatusMessageProps {
  status: number
}

const StatusMessage = ({ status }: StatusMessageProps) => {
  const firstCheckColor = status === 1 || status === 2 ? '#09E16C' : '#593b7e'
  const secondCheckColor = status === 2 ? '#09E16C' : '#593b7e'

  return (
    <Row className="min-h-fit min-w-fit">
      <Check
        size={16}
        color={firstCheckColor}
        className="transition-colors duration-300"
      />
      <Check
        size={16}
        className="-ml-1.5 transition-colors duration-300"
        color={secondCheckColor}
      />
    </Row>
  )
}

export default StatusMessage
